import React from 'react';
import Card from '../Common/Card';
import { formatUSDT } from '../../utils/format';

const DirectReferrals = ({ directs }) => {
  return (
    <Card title="Direct Referrals" subtitle={`Total: ${directs?.length || 0}`}>
      {!directs || directs.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">◌</div>
          <div className="empty-state-text">No direct referrals yet</div>
        </div>
      ) : (
        <div className="table-wrap" style={{ background: 'transparent', border: 'none' }}>
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Investment</th>
                <th>Team Volume</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {directs.map((d) => (
                <tr key={d.id}>
                  <td className="numeric">#{d.id}</td>
                  <td className="numeric">{formatUSDT(d.totalInvestment)} USDT</td>
                  <td className="numeric">{formatUSDT(d.teamVolume)} USDT</td>
                  <td>
                    {d.active ? (
                      <span className="badge badge-green"><span className="badge-dot" />Active</span>
                    ) : (
                      <span className="badge badge-muted">Inactive</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
};

export default DirectReferrals;
